export { SpaLandingPageConnected as SpaLandingPage } from './container';
